export function RocketIcon(props) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.8767 15.5158C19.8445 12.0469 22.8471 5.26536 21.0935 3.51175C19.3399 1.75814 12.5583 4.76075 9.08943 8.72856C6.8843 9.25328 2.4212 12.4164 3.06236 13.0576C3.38312 13.3784 5.11006 13.1972 7.03406 12.8721C6.93911 14.0457 7.32184 15.1959 8.36558 16.2397C9.40932 17.2834 10.5596 17.6661 11.7331 17.5712C11.4081 19.4952 11.2268 21.2222 11.5476 21.543C12.1887 22.1841 15.352 17.721 15.8767 15.5158ZM17.9115 8.10794C17.521 8.49844 16.8878 8.49844 16.4973 8.10794C16.1068 7.71745 16.1068 7.08423 16.4973 6.69373C16.8878 6.30323 17.521 6.30323 17.9115 6.69373C18.302 7.08423 18.302 7.71745 17.9115 8.10794Z"
        fill="currentColor"
      />
      <path
        d="M3.76938 20.8359C4.55038 21.6169 7.23094 20.2027 8.01202 19.4217C8.79311 18.6406 8.79302 17.3742 8.01202 16.5932C7.23103 15.8122 5.96468 15.8121 5.1836 16.5932C4.40252 17.3743 2.98839 20.0549 3.76938 20.8359Z"
        fill="currentColor"
      />
    </svg>
  );
}
